import React from 'react';
import {ResultsModel} from '../model/results.model';

const ResultsContext = React.createContext<ResultsModel>({
    userId: '',
    profession: '',
    showResultsForProfessionals: false,
    changeShowResultsForProfessionals: (value: boolean): void => {},
    changeProfession: (value: string): void => {},
    agreeToTerms: false,
    changeAgreeToTerms: (value: boolean): void => {},
    licenseNumber: '',
    changeLicenseNumber: (value: string): void => {},
    birthDate_18_to_49: false,
    on_birthDate_18_to_49: (value: boolean): void => {},
    birthDate_50_to_54: false,
    on_birthDate_50_to_54: (value: boolean): void => {},
    birthDate_55_to_59: false,
    on_birthDate_55_to_59: (value: boolean): void => {},
    birthDate_60_to_64: false,
    on_birthDate_60_to_64: (value: boolean): void => {},
    birthDate_over_65: false,
    on_birthDate_over_65: (value: boolean): void => {},
    dateOfBirth: null,
    onDateOfBirth: (value: Date | null): void => {},
    pregnancy: false,
    onPregnancy: (value: boolean) => {},
    plannedPregnancy: false,
    onPlannedPregnancy: (value: boolean) => {},
    circulatorySystemDisease: false,
    onCirculatorySystemDisease: (value: boolean) => {},
    diabetes: false,
    onDiabetes: (value: boolean) => {},
    chronicRespiratoryDisease: false,
    onChronicRespiratoryDisease: (value: boolean) => {},
    chronicKidneyDisease: false,
    onChronicKidneyDisease: (value: boolean) => {},
    chronicLiverDisease: false,
    onChronicLiverDisease: (value: boolean) => {},
    viralHepatitisC: false,
    onViralHepatitisC: (value: boolean) => {},
    depression: false,
    onDepression: (value: boolean) => {},
    neoplasticDisease: false,
    onNeoplasticDisease: (value: boolean) => {},
    spleenDysfunction: false,
    onSpleenDysfunction: (value: boolean) => {},
    immuneDisorders: false,
    onImmuneDisorders: (value: boolean) => {},
    immunosuppressiveDrugs: false,
    onImmunosuppressiveDrugs: (value: boolean) => {},
    hivInfection: false,
    onHivInfection: (value: boolean) => {},
    boneMarrowTransplantation: false,
    onBoneMarrowTransplantation: (value: boolean) => {},
    boneMarrowTransplantationBefore: false,
    onBoneMarrowTransplantationBefore: (value: boolean) => {},
    boneMarrowTransplantationAfter: false,
    onBoneMarrowTransplantationAfter: (value: boolean) => {},
    organTransplantation: false,
    onOrganTransplantation: (value: boolean) => {},
    organTransplantationBefore: false,
    onOrganTransplantationBefore: (value: boolean) => {},
    organTransplantationAfter: false,
    onOrganTransplantationAfter: (value: boolean) => {},
    cochlearImplantation: false,
    onCochlearImplantation: (value: boolean) => {},
    cerebroSpinalFluidLeak: false,
    onCerebroSpinalFluidLeak: (value: boolean) => {},
    autoimmuneDisease: false,
    onAutoimmuneDisease: (value: boolean) => {},
    medicalStudentHealthcare: false,
    onMedicalStudentHealthcare: (value: boolean) => {},
    neonatologyPediatricsWorker: false,
    onNeonatologyPediatricsWorker: (value: boolean) => {},
    infectiousDiseasesGastroenterologyWorker: false,
    onInfectiousDiseasesGastroenterologyWorker: (value: boolean) => {},
    workingWithSevereImmunodeficiency: false,
    onWorkingWithSevereImmunodeficiency: (value: boolean) => {},
    policeman: false,
    onPoliceman: (value: boolean) => {},
    fireFighter: false,
    onFireFighter: (value: boolean) => {},
    borderGuard: false,
    onBorderGuard: (value: boolean) => {},
    army: false,
    onArmy: (value: boolean) => {},
    healthCareHomeResident: false,
    onHealthCareHomeResident: (value: boolean) => {},
    otherMultiPersonPlace: false,
    onOtherMultiPersonPlace: (value: boolean) => {},
    outdoorActivity: false,
    onOutdoorActivity: (value: boolean) => {},
    hepatitisBExposure: false,
    onHepatitisBExposure: (value: boolean) => {},
    cigarettesAlcoholAbuse: false,
    onCigarettesAlcoholAbuse: (value: boolean) => {}
    });

export default ResultsContext;
